import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
@Component({
  selector: 'app-audit-dialog',
  templateUrl: './audit-dialog.component.html',
  styleUrls: ['./audit-dialog.component.scss']
})
export class AuditDialogComponent {
  voucher_posting_id: number;
  audit: string = '';
  remark: string = '';
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<AuditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { voucher_posting_id?: number; }
  ) {
    console.log('formdata', data);
  }

  onSave(auditForm: any): void {
    auditForm.submitted = true;
    if (!this.audit) {
      alert('Please Enter Audit type');
      return;
    }

    if (this.audit=="2" && !this.remark ) {
      alert('Please Give remark');
      return;
    }
    const payload = {
      voucher_posting_id: this.data?.voucher_posting_id,
      audit: this.audit,
      remark: this.remark,
    };
    if (this.data?.voucher_posting_id) {
      this.apiService.audit(payload).subscribe(
        updatedAudit => {
          console.log('audit successfully:', updatedAudit);
          this.dialogRef.close({
            audit: this.audit,
            remark: this.remark,
          });
        },
        error => {
          console.error('Error updating statement:', error);
        }
      );

    }
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
